var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var injectRoute = function (_a) {
    var router = _a.router, injectedRoute = _a.injectedRoute;
    try {
        var prevRoutes = router.getDependencies().routes;
        router.setDependencies({
            routes: __spreadArray(__spreadArray([], prevRoutes, true), [injectedRoute], false),
        });
        router.add([injectedRoute]);
    }
    catch (error) {
        console.error('Error in injectRoute', error);
    }
};
